import React from 'react';
import { useTranslation } from 'react-i18next';
import { Accordion, Panel, List, ListItem, Section, SectionTitle, Typography } from 'common/components';
import { analyticsUtils } from 'utils/analytics-utils';
import { WINDOWS_ELEMENT_BLOCK } from '../../windows-constants';
import {
  questionAccordion,
  questionDescriptionSubList,
  questionDescriptionText,
  questionSectionTitle,
} from './windows-question-section-styles';

export const WindowsQuestionSection = () => {
  const { t } = useTranslation();
  /**
   * Обработчик нажатия на колапс панели
   */

  const handlePanelClick = (question: string) => (_: string, isOpen: boolean) => {
    if (!isOpen) {
      analyticsUtils.clickButtonEvent(WINDOWS_ELEMENT_BLOCK, question.slice(0, 100), t('question-section.title'));
    }
  };

  return (
    <Section itemScope itemType="https://schema.org/FAQPage">
      <SectionTitle className={questionSectionTitle} variant="h2">
        {t('question-section.title')}
      </SectionTitle>

      <Accordion className={questionAccordion}>
        <Panel name="antiMoisture" onClick={handlePanelClick(t('question-section.anti-moisture.title'))} title={t('question-section.anti-moisture.title')}>
          <div itemScope itemProp="acceptedAnswer" itemType="https://schema.org/Answer">
            <Typography itemProp="text" className={questionDescriptionText} variant="s" size="body_long">
              {t('question-section.anti-moisture.answer1')}
            </Typography>
          </div>
        </Panel>
        <Panel
          name="ventilationValves"
          onClick={handlePanelClick(t('question-section.ventilation-valves.title'))}
          title={t('question-section.ventilation-valves.title')}>
          <div itemScope itemProp="acceptedAnswer" itemType="https://schema.org/Answer">
            <Typography itemProp="text" className={questionDescriptionText} variant="s" size="body_long">
              {t('question-section.ventilation-valves.answer1')}
            </Typography>
          </div>
        </Panel>
        <Panel name="care" onClick={handlePanelClick(t('question-section.care.title'))} title={t('question-section.care.title')}>
          <div itemScope itemProp="acceptedAnswer" itemType="https://schema.org/Answer">
            <Typography itemProp="text" className={questionDescriptionText} variant="s" size="body_long">
              {t('question-section.care.answer1')}
            </Typography>
          </div>
        </Panel>
        <Panel
          name="privateHouse"
          onClick={handlePanelClick(t('question-section.private-house.title'))}
          title={t('question-section.private-house.title')}>
          <div itemScope itemProp="acceptedAnswer" itemType="https://schema.org/Answer">
            <Typography itemProp="text" className={questionDescriptionText} variant="s" size="body_long">
              {t('question-section.private-house.answer1')}
            </Typography>
          </div>
        </Panel>
        <Panel name="children" onClick={handlePanelClick(t('question-section.children.title'))} title={t('question-section.children.title')}>
          <div itemScope itemProp="acceptedAnswer" itemType="https://schema.org/Answer">
            <div itemProp="text">
              <Typography className={questionDescriptionText} variant="s" size="body_long">
                {t('question-section.children.answer1')}
              </Typography>
              <Typography className={questionDescriptionText} variant="s" size="body_long">
                {t('question-section.children.answer2')}
              </Typography>
              <List className={questionDescriptionSubList} listStyle="disc">
                <ListItem text={t('question-section.children.answer3') || ''} variant="s" />
                <ListItem
                  text={t('question-section.children.answer4') || ''}
                  variant="s"
                />
                <ListItem
                  text={t('question-section.children.answer5') || ''}
                  variant="s"
                />
                <ListItem
                  text={t('question-section.children.answer6') || ''}
                  variant="s"
                />
              </List>
            </div>
          </div>
        </Panel>
        <Panel
          name="individualDesign"
          onClick={handlePanelClick(t('question-section.individual-design.title'))}
          title={t('question-section.individual-design.title')}>
          <div itemScope itemProp="acceptedAnswer" itemType="https://schema.org/Answer">
            <Typography itemProp="text" className={questionDescriptionText} variant="s" size="body_long">
              {t('question-section.individual-design.answer1')}
            </Typography>
          </div>
        </Panel>
      </Accordion>
    </Section>
  );
};
